import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cache = new Map<string, BehaviorSubject<any>>();

  constructor() {}

  getCache<T>(key: string): BehaviorSubject<T | null> {
    if (!this.cache.has(key)) {
      this.cache.set(key, new BehaviorSubject<T | null>(null));
    }
    return this.cache.get(key) as BehaviorSubject<T | null>;
  }

  setCache<T>(key: string, value: T): void {
    const cacheSubject = this.getCache<T>(key);
    cacheSubject.next(value);
  }

  clearCache(key: string): void {
    if (this.cache.has(key)) {
      this.cache.get(key)?.next(null);
    }
  }

  clearAllCaches(): void {
    this.cache.forEach((subject) => subject.next(null));
  }
}
